import { ProgressDto } from './progress.dto';

export type ProgressItemType = 'lesson' | 'quiz';

export class Progress {
    readonly itemId: string;
    readonly itemType: ProgressItemType;
    readonly lessonId: string | null;
    readonly quizId: string | null;
    readonly moduleId: string;
    readonly courseId: string;
    readonly completed: boolean;
    readonly completedDate: number | null;

    constructor(dto: ProgressDto) {
        this.lessonId = dto.lessonId ?? null;
        this.quizId = dto.quizId ?? null;
        this.itemId = dto.lessonId ?? dto.quizId ?? '';
        this.itemType = dto.lessonId ? 'lesson' : 'quiz';
        this.moduleId = dto.moduleId;
        this.courseId = dto.courseId;
        this.completed = dto.completed;
        this.completedDate = dto.completedDate ? new Date(dto.completedDate).getTime() : null;
    }
}
